import getConfig from 'next/config';

import {getApiRequest, postApiRequest} from '~/src/utilities/feed/api.js';
import {userIsLoggedIn, login} from '~/src/utilities/helpers/account';
import {refreshOrShouldLogin} from '~/src/utilities/helpers/login';
import {trackEvent} from '~/src/utilities/tracking/beagle';
import {ApiTypes} from '~/src/utilities/constants/types';
import {Logger} from '~/src/utilities/helpers/log';

const {publicRuntimeConfig: config} = getConfig();

const sendActivityRequest = async (actionType, actionPath, assetId, contentType, apiType = '') => {
    const isLoggedIn = userIsLoggedIn();
    if (await refreshOrShouldLogin(isLoggedIn)) {
        return login();
    }

    const userPath = isLoggedIn ? 'user' : 'anonymous';

    const data = {
        data: {
            type: actionType,
            attributes: {
                tenant: config.tenantId.toString(),
                asset: {
                    id: assetId.toString(),
                    type: contentType
                }
            }
        }
    };

    try {
        return await postApiRequest(`${config.feeds.activity}/${userPath}/${actionPath}`, data, true);
    } catch (error) {
        Logger.info(`[${error.name}][activity] error while sending activity request: ${apiType}`, {error});
    }
};

const sendShareRequest = async (assetId, beagleEvent, contentType, platform) => {
    trackEvent(beagleEvent, {resourceId: assetId, platform: platform});
    await sendActivityRequest('share', 'shares', assetId, contentType, ApiTypes.SHARE);
};

const loadActivityFeed = (limit = 5, page = '') =>
    getApiRequest(`${config.feeds.activityNewest}?limit=${limit}&page=${page}&tenantID=${config.tenantId.toString()}`, true);

export {sendShareRequest, loadActivityFeed};
